import {TemplateConfig} from '../types';

export const splitConfig: TemplateConfig = {
  id: 'split',
  name: 'templates.split.name',
  description: 'templates.split.description',
  photoSectionRatio: {
    landscape: {width: 2 / 3, height: 1},
    portrait: {width: 1, height: 2 / 3},
  },
};

export default splitConfig;
